import React from 'react';

export function RouteNotFound404(props) {

    window.location.href = process.env.REACT_APP_HOST_API_URL + "/page-not-found";
  return (
      <div>
        Page not found
      </div>
  );
}



// WEBPACK FOOTER //
// ./src/RouteNotFound404.js